import React from 'react'
import { PrizeItem } from '../server/prizes/list/get'
import { useAxios } from '../hooks/useAxios'
import { ReactSVG } from 'react-svg'
import Btn from './Btn'
import { getPrize } from '../api/getPrize'
import { UserStore } from '../store/userStore'
import Card from './Card'
import Dialog from './Dialog'

const PrizeCard: React.FC<PrizeItem> = (prize) => {
  const { response, fire, loading, error } = useAxios()
  const [dialogOpen, setDialogOpen] = React.useState(false)
  const handler = async () => {
    const { response, error } = await fire(getPrize(prize.id))

    if (!error && response?.data?.token) {
      localStorage.setItem('token', response?.data?.token)
      UserStore.updateUserData()
    }

    setDialogOpen(true)
  }

  return (
    <div className={'prize-card'}>
      <div className={'prize-card__picture'}>
        {prize.pictureUrl && <img src={prize.pictureUrl} alt={prize.name} />}
      </div>

      <div className={'prize-card__content'}>
        <div className={'prize-card__coin'}>
          <ReactSVG src={'/i/svg/coin.svg'} className={'svg-icon'}></ReactSVG>
          <span>{prize.cost}</span>
        </div>

        <h3 className={'prize-card__title text-h4'}>{prize.name}</h3>

        <Btn onClick={handler} loading={loading} className={'prize-card__btn'}>
          Получить
        </Btn>

        <Dialog
          render={(close) => {
            return (
              <Card
                className={'u-flex u-flexCol u-flexAlignItemsCenter'}
                style={{ maxWidth: '40rem' }}
              >
                <header className={'card-head _centered'}>
                  <p className={'card-head__title text-h3'}>Сообщение</p>
                </header>

                <div className={'card-content'}>
                  {error ? error.message : response?.data?.message ?? 'Успешно'}
                </div>

                <footer className={'card-foot'}>
                  <Btn onClick={() => close()}>Закрыть</Btn>
                </footer>
              </Card>
            )
          }}
          value={dialogOpen}
        ></Dialog>
      </div>
    </div>
  )
}

export default PrizeCard
